import axios from 'axios';

const noop = function(){};

void function () {
  const ie = !!(window.attachEvent && !window.opera);
  const wk = /webkit\/(\d+)/i.test(navigator.userAgent) && (RegExp.$1 < 525);
  const fn = [];
  const run = function () {
    for (let i = 0; i < fn.length; i++){
      fn[i]();
    };
    fn.length = 0;
  };
  const d = document;
  d['ready'] = function (f) {
    if (!ie && !wk && d.addEventListener){
      return d.addEventListener('DOMContentLoaded', f, false);
    }
    if (fn.push(f) > 1){ return; }
    if (ie) {
      let sto;
      void function _try() {
        sto && clearTimeout(sto);
        try {
          d.documentElement.doScroll('left');
          run();
        } catch (err) {
          return (sto = setTimeout(_try, 10));
        }
      }();
    } else if ( wk ) {
      const t = setInterval(function () {
        if (/^(loaded|complete)$/.test(d.readyState)){
          clearInterval(t);
          run();
        }
      }, 0);
    }
  };
}();

let AMap;
let VConsole;
let wx;
let jsSdk;

function _loadjs(g){
  return function( vue, store ){
    document.ready(function(){
      // console.error('document ready !!!', Date.now());
      AMap = g['AMap'] || {};
      VConsole = g['VConsole'] || noop;
      wx = g['wx'];

      vue.$emit('document_ready', vue);

      if ( VConsole !== noop && navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 ) {
        if (store && store.state && store.state.isDev) {
          // new VConsole();
        }
      }
    });
  }
}

function _loadjsV2(g){
  return function( vue ){
    const sto = setInterval(function(){
      const arr = ['AMap', 'wx', 'VConsole'];
      for( let vendor of arr ){
        if( !g[ vendor ] ){
          return;
        }
      }
      clearInterval(sto);
      AMap = g['AMap'];
      VConsole = g['VConsole'];
      wx = g['wx'];
      console.error('vendor_js_ready');
      vue.$emit('vendor_js_ready', vue);

      if ( navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 ) {
          // new VConsole();
      }
    }, 30);
  }
}

// 每个页面只需要调用一次
// 如果需要在页面打开的时候就立即执行，就在then()里面调用微信api
// 否则就在用户点击的时候触发微信api
jsSdk = function(customer, jsApiList, url = ''){
  if( !customer ){ throw 'no customer'; }
  url = url || window.location.href;
  return new Promise((resolve, reject)=>{
    if( !wx ){ reject('wx未加载'); }
    axios.get('/v3/u/user/getWxJsSdk', {params:{customer, url}}).then(function(data){
      // console.log('/wx/getJsSdk', data.data.data);
      wx.config({
        ...data.data.data,
        debug:false,
        jsApiList: jsApiList,//['getLocation'],
        openTagList:['wx-open-launch-weapp']
      });
      if( !/MicroMessenger/i.test(navigator.userAgent) ){//Chrome下调试
        console.log('chrome: ', navigator.userAgent);
        return resolve('');
      }
      wx.error(console.log);
      wx.ready(function(){
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后
        // config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。
        // 对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
        // console.log( 'ready:', url, JSON.stringify(jsApiList) );
        return resolve(wx);
      });
    });
  });
};






const loadjs = _loadjs(window);

export{
  loadjs,
  AMap,
  VConsole,
  wx,
  jsSdk,
}
